var AccountType = /* @__PURE__ */ ((AccountType2) => {
  AccountType2["NotRegistered"] = "NotRegistered";
  AccountType2["Full"] = "FULL";
  AccountType2["Light"] = "LIGHT";
  AccountType2["Locked"] = "LOCKED";
  return AccountType2;
})(AccountType || {});
var LockedStatus = /* @__PURE__ */ ((LockedStatus2) => {
  LockedStatus2["Locked"] = "locked";
  LockedStatus2["LockedRuntastic"] = "locked-cci";
  return LockedStatus2;
})(LockedStatus || {});
var LoginOption = /* @__PURE__ */ ((LoginOption2) => {
  LoginOption2["Password"] = "password";
  LoginOption2["Social"] = "social";
  return LoginOption2;
})(LoginOption || {});
export {
  AccountType,
  LockedStatus,
  LoginOption
};
//# sourceMappingURL=email-detection-types.js.map
